import { action } from 'mobx';
import BaseStore from 'core/stores/BaseStore';
import { PackingSlipService } from 'common/data';

class PackingSlipStore extends BaseStore {
	constructor(rootStore) {
		super(new PackingSlipService(rootStore.app.baasic.apiClient));
	}

	@action
	async generatePdf(id) {
		const response = await this.service.generatePdf(id);
		this.response = response.data;
		return this.response;
	}
}

export default PackingSlipStore;



// WEBPACK FOOTER //
// ./src/modules/packing-slip/stores/PackingSlipStore.js